import axios from 'axios';

export const fetchData = async (inputQuery) => {
  const endpoint = "https://wmastover--wikiai-web.modal.run";
  const params = {
    params: {
      'query': inputQuery,
    }
  };

  try {
    const response = await axios.get(endpoint, params);
    if (response.status === 200) {
      return (response.data);
    } else {
      console.log(`Request failed with status code: ${response.status}`);
    }
  } catch (error) {
    console.error(`Error in making request: ${error}`);
  }
};

